import '/components/table/table.scss';
